<template>
  <div class="OwnScreening">
    <div class="sdHome">
      <div
        v-if="routeName === '/'"
        class="col-12 sliderDetails px-0 pr-md-3 px-lg-3"
      >
        <p class="movieCat">CHOOSE YOUR MOVIE
          <span class="txt-link">
            <router-link class="ml-3 ml-lg-4 mr-2" to
              >Watch Movies on Demand</router-link
            >
            <!-- <img
              id="tooltip-3"
              title="Tooltip content"
              src="@/assets/img/svg/info-rd-icon.svg"
              class="rounded-circle"
            /> -->
            <button class="btn btn-danger viewmore-btn mr-4" @click="showModal = true">Know more</button>
          </span>
          <b-modal v-model="showModal" ok-variant="danger" >
            <ul>
              <li>Creating your own cinema screening is simple.</li>
              <li>
                Just pick the movie you like from a large library of the movies
                available.
              </li>
              <li>Complete the booking by selecting</li>
              -Private Screening: Book the entire Cinema right now just for
              yourself.
              <br />-Confirmed Screening: Book the tickets for a crowdsourced
              screening to be confirmed
              <br />-Confirmed Screening: Book the minimum tickets and confirm
              the screening right now
              <br />
              <li>and Invite your friends.</li>
              <li>If enough people book tickets by the date stated.</li>
              <li>Your screening is confirmed.</li>
              <li>
                Don’t worry if the screening isn’t confirmed which rarely
                happens, you get the refund within 48 hours
              </li>
            </ul>
  </b-modal>
          <!-- ToolTip -->
          <b-tooltip target="tooltip-3" placement="right">
            
          </b-tooltip>
        </p>
        <p class="link">
          <router-link :to="{ name: 'createScreenList' }"
            >(See All)</router-link
          >
        </p>
      </div>
    </div>

    <div class="sd">
      <div v-if="routeName !== '/'" class="col-12 sliderDetails px-0 px-md-3">
        <p class="movieCat">
          CREATE YOUR OWN SCREENING
          <span class="link ml-2">
            <router-link :to="{ name: 'createScreenList' }"
              >(See All)</router-link
            >
          </span>
        </p>
      </div>
    </div>

    <Slick ref="slick3" :options="movieSlider">
      <div
        v-for="(singleMovie, singleMovieIndex) in OwnScreening"
        :key="singleMovieIndex"
      >
        <div class="movieSlider-container mx-auto text-center">
          <div class="img-container">
            <router-link v-on:click.native="goToRoute(singleMovie)" to>
              <!-- :to="{ name: 'createScreen', params: { movieId: singleMovie.ID,categoryId: 4 }}" -->
              <img
                v-lazy="singleMovie.md_thumbnail_url"
                alt
                class="img-fluid mx-auto banner"
              />
            </router-link>

            <div class="img-logo">
              <router-link v-on:click.native="goToRoute(singleMovie)" to>
                <!-- :to="{ name: 'createScreen', params: { movieId: singleMovie.ID,categoryId: 4 }}" -->
                <!-- <img src="@/assets/img/svg/gogo-small-icon.svg" class="img-fluid" /> -->
              </router-link>
            </div>
          </div>
          <div class="text-center mx-auto pt-2 pt-md-3 movieSliderInfo">
            <p class="mb-0 title">{{ singleMovie.movie_title }}</p>
            <ul class="list-inline mb-0 mInfo">
              <li class="list-inline-item">{{ singleMovie.mf_name }}</li>
              <li class="list-inline-item">|</li>
              <li class="list-inline-item">{{ singleMovie.rating }}</li>
            </ul>
          </div>
        </div>
      </div>
    </Slick>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import $ from "jquery";
import MainServices from "@/services/mainService.js";
import { URL_BASE, LIMIT } from "@/helper/constants";
import moment from "moment";
export default {
  name: "OwnScreeningSlider",

  components: {
    Slick
  },

  data() {
    return {
      showModal: false,
      movieSlider: {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 4,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      },
      OwnScreening: [],
      routeName: ""
    };
  },
  mounted() {
    this.routeName = window.location.pathname;

    this.getNowShowingData();
  },
  methods: {
    getNowShowingData: function() {
     let payload = {limit:LIMIT,currentPage:1}
     
      MainServices.GetCreateOwnShow(payload)
        .then(response => {
          const { data } = response;
          console.log("response", response);
          if (data.status) {
            this.OwnScreening = data.Records.data;
            this.$refs.slick3.destroy();
            this.$nextTick(() => {
              this.$refs.slick3.create();
              this.$refs.slick3.goTo(1, true);
            });
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    goToRoute: function(singleMovie) {
      console.log("object");
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.$router.push({
                  name: 'createScreen',
                  params: {
                    movie_id: singleMovie.movie_id,
                    content_lang_id: singleMovie.content_lang_id
                  }
        });
    
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/OwnScreeningSlider.vue